import useMobile from "customHooks/useMobile";
import { nextCheckoutItemSourceManager } from "customHooks/useNextCheckoutItemSource";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect } from "react";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import SEO from "../components/Seo";
import useLastPath from "../customHooks/useLastPath";

const transparencyTranslations = {
  transparency: {
    title: "transparency_file",
    desc: "transparency_desc",
    breadcrumb: "transparency_file",
  },
  donations: {
    title: "sections_transparency_donations_title",
    desc: "sections_transparency_donations_desc",
    breadcrumb: "sections_transparency_donations_breadcrumb",
  },
};
const TransparencyLayout = ({ children }) => {
  const lastPath = useLastPath();
  const { t } = useTranslation("common");
  const isMobile = useMobile("md");
  const { asPath } = useRouter();
  const lastPathChecker = () => {
    return !isNaN(Number(lastPath))
      ? asPath.split("?")[0].split("/")[asPath.split("/").length - 2]
      : lastPath;
  };
  useEffect(() => {
    nextCheckoutItemSourceManager.setNextCheckoutItemSource(
      nextCheckoutItemSourceManager.options.transparency
    );
  }, []);
  return (
    <>
      <SEO
        title={
          t(transparencyTranslations[lastPathChecker()]?.title) ||
          t("transparency")
        }
        description={t(transparencyTranslations[lastPathChecker()]?.desc)}
        // image={`/api/og/transparency?locale=${locale}`}
      />
      <div className="mb-3">
        <CustomJumbotron
          p="py-4 px-0"
          m="my-0"
          title={t(transparencyTranslations[lastPathChecker()]?.title)}
          desc={t(transparencyTranslations[lastPathChecker()]?.desc)}
          customBreadCrumbs={
            <CustomBreadCrumbs
              transformedLabel={(title) => {
                if (!isNaN(Number(lastPath)) && !isNaN(Number(title)))
                  return dateFormatter(lastPath);

                return t(transparencyTranslations[title]?.breadcrumb);
              }}
            />
          }
        />
        <div className={`${!isMobile && "container px-0"}`}>{children}</div>
      </div>
    </>
  );
};

export default TransparencyLayout;
function dateFormatter(date) {
  return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
}
